import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobNote } from "@/types";

/**
 * This hook is used to update a job note in the job notes query
 * without refetching the entire query.
 */
export const useSetJobNote = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobNoteToUpdate }: { jobNoteToUpdate: JobNote }) => {
    queryClient.setQueryData(
      ["job-notes", currentCompanyId, currentJobId],
      (cachedData: JobNote[]) => {
        return cachedData.map((jobNote) => {
          if (jobNote.id === jobNoteToUpdate.id) {
            return jobNoteToUpdate;
          }
          return jobNote;
        });
      },
    );
  };
};
